module.exports = __webpack_public_path__ + "img/bg_06.ac4badfe.png";